import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "completion2-footer-buttons" }

import { completionTwoStore } from '@/stores/completionTwo'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Group } from '@/types/completion2/group'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion2FooterButtons',
  setup(__props) {

const router = useRouter()

const nextElementIndex = computed(() => {
  let nextElementIndex = null
  const currentElementIndex = completionTwoStore().current.elementIndex

  completionTwoStore().elements.forEach((g:{ id:number, name:string, position:number, selectorType:string, mirrored:boolean }, i:number) => {
    if (currentElementIndex !== null && i === currentElementIndex + 1) {
      nextElementIndex = i
    }
  })

  return nextElementIndex
})

const nextGroupId = computed(() => {
  let nextGroupId:number|null = null
  let currentGroupIndex:number|null = null

  completionTwoStore().groups.forEach((g:Group, i:number) => {
    if (g.id === completionTwoStore().current.group) { currentGroupIndex = i }
    if (currentGroupIndex !== null && i === currentGroupIndex + 1) { nextGroupId = g.id }
  })

  return nextGroupId
})

const nextRoomId = computed(() => {
  let nextRoomId:number|null = null
  let currentRoomIndex:number|null = null

  completionTwoStore().rooms.forEach((r:{ id:number, name:string, layoutId:number }, i:number) => {
    if (r.id === completionTwoStore().current.room) { currentRoomIndex = i }
    if (currentRoomIndex !== null && i === currentRoomIndex + 1) { nextRoomId = r.id }
  })

  return nextRoomId
})

const nextLevelId = computed(() => {
  let nextLevelId:number|null = null
  let currentLevelIndex:number|null = null

  completionTwoStore().levels.forEach((l:{ id:number, name:string }, i:number) => {
    if (l.id === completionTwoStore().current.level) { currentLevelIndex = i }
    if (currentLevelIndex !== null && i === currentLevelIndex + 1) { nextLevelId = l.id }
  })

  return nextLevelId
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(nextElementIndex))
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "primary",
          style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
          disabled: _unref(completionTwoStore)().menuDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(completionTwoStore)().setElement(_unref(nextElementIndex))))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Volgende element")
          ]),
          _: 1
        }, 8, ["style", "disabled"]))
      : (_unref(nextGroupId))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
            disabled: _unref(completionTwoStore)().menuDisabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(completionTwoStore)().setGroup(_unref(nextGroupId))))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Volgende groep")
            ]),
            _: 1
          }, 8, ["style", "disabled"]))
        : (_unref(nextRoomId))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "primary",
              style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
              disabled: _unref(completionTwoStore)().menuDisabled,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(completionTwoStore)().setRoom(_unref(nextRoomId))))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volgende ruimte")
              ]),
              _: 1
            }, 8, ["style", "disabled"]))
          : (_unref(nextLevelId))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 3,
                type: "primary",
                style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                disabled: _unref(completionTwoStore)().menuDisabled,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(completionTwoStore)().setLevel(_unref(nextLevelId))))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Volgende verdieping")
                ]),
                _: 1
              }, 8, ["style", "disabled"]))
            : (_openBlock(), _createBlock(_component_a_button, {
                key: 4,
                type: "primary",
                style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                disabled: _unref(completionTwoStore)().menuDisabled,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'Completion3' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Naar afbouw 3")
                ]),
                _: 1
              }, 8, ["style", "disabled"]))
  ]))
}
}

})